import { login } from "./loginKs";
import device from "~/utils/device";
import sleep from "@ky/sdk/dist/sleep";
import ToastModal from "./modal/toastModal.vue";
import Cookies from "js-cookie";
import { KLING_HOME_CREATE } from "./constants";
import loginKy from "@ky/sdk/dist/login";
import open from "@ky/sdk/dist/open";

import getCookie from "@ky/sdk/dist/getCookies";

const toastModal = new ApiModal<typeof ToastModal>(ToastModal, null, {
  sync: true,
});
let hasPermission = 0;
const expire = 1000 * 60; // 一分钟免检查
//设置cookie的值
function setCookieValue(name: string, value: string, time:any) {
  const now = new Date();
  const offset = 8;
  const utc = now.getTime() + now.getTimezoneOffset() * 60000;
  const nd = utc + 3600000 * offset;
  const exp = new Date(nd);
  const domain = document.domain;
  exp.setTime(exp.getTime() + time * 60 * 60 * 1000);
  document.cookie =
    name +
    "=" +
    escape(value) +
    ";path=/;expires=" +
    // @ts-ignore
    exp.toGMTString() +
    ";domain=" +
    domain +
    ";";
  console.log("cookie", document.cookie);
}
async function addCookie() {
  const api_st = (await Cookies.get("ky.api_st")) || "";
  const passToken = (await Cookies.get("passToken")) || "";
  const userId = (await Cookies.get("userId")) || "";
  setCookieValue("userId", userId, 10);
  setCookieValue("ky.api_st", api_st, 10);
  setCookieValue("passToken", passToken, 10);
}
/** 检查登录及权限问题 */
export default async function checkPermission() {
  const isPC = device.isPC;
  if (!isPC) return Promise.resolve();
  if (hasPermission && Date.now() - hasPermission < expire) {
    return Promise.resolve();
  }
  return login()
    .then((res) => {
      if (res.result === 1) {
        hasPermission = Date.now();
        return res;
      }

      return res;
    })
    .catch((e) => {
      if (!e) return Promise.reject({});
      toastModal.show({
        type: "loginError",
        toastSmall: true,
        desc: e?.errorMsg,
      });
      return Promise.reject(e);
    });
}

/** 检查移动端环境 */
export async function checkMobile() {
  const isKyMobile = device.isKy;
  const isMobile = device.isIOS || device.isAndroid;
  if (isKyMobile) {
    const userId = Cookies.get("userId");
    if (!userId) {
      // 快影端内未登录
      const res = await loginKy(0);
      if (res.result !== 1) {
        throw new Error("未登录");
      }
      window?.kwaiying?.updateCookie?.();
      if (device.isIOS) {
        await sleep(1000);
        await addCookie();
      }
    }
  } else if (isMobile) {
    await new Promise((resolve, reject) => {
      toastModal.show({
        type: "openKy",
        autoClose: false,
        toastSmall: true,
        onClose: () => {
          reject();
        },
        //@ts-ignore
        onConfirm: () => {
          reject();
          open(
            `kwaiying://web?url=${encodeURIComponent(window.location.href)}&showTopBar=false`,
          );
        },
      });
    });
  }
}

export async function noPermission() {
  await new Promise((resolve, reject) => {
    toastModal.show({
      type: "loginKwai",
      autoClose: false,
      toastSmall: true,
      onClose: () => {
        reject();
      },
      //@ts-ignore
      onConfirm: () => {
        open(`kwaiying://setting`);
      },
    });
  });
}

/** 检查整个环境 */
export async function checkAuth() {
  await checkMobile();
  await checkPermission();
}
